export enum COMPONENT_TYPES {
  ArticlesWithTagSlider = "ArticlesWithTagSlider",
  FaqListWithTitle = "FaqListWithTitle",
  ContentImageDesc = "ContentImageDesc",
  TopTips = "TopTips",
  BannerWithImage = "BannerWithImage",
  Quote = "Quote",
  VideoWidget2 = "VideoWidget2",
  ClusterActionCards = "ClusterActionCards",
  Index = "Index",
}
